"use strict";

/* "Choose your breakfast" — one preview row under the banner.
   Two jobs: drive the sideways scroll (arrows + progress rail) and flash
   the check on the "+" before the form navigates. The add itself is a
   plain form post with return_to, so it works with JS disabled too —
   nothing here touches the cart. Base switching lives in gr-base-choice.js. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.gr-featured-types').forEach(section => {
    const track = section.querySelector('[data-ft-track]');
    const cards = section.querySelectorAll('.gr-ft-card');
    if (!track || !cards.length) return;

    const controls = section.querySelector('[data-ft-controls]');
    const thumb = section.querySelector('[data-ft-thumb]');
    const prev = section.querySelector('[data-ft-prev]');
    const next = section.querySelector('[data-ft-next]');

    /* One "page" is whatever is currently in frame, minus a card so the last
       visible bottle carries over and the eye keeps its place. */
    const step = () => {
      const card = [...cards].find(c => !c.hidden);
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const cardW = card.getBoundingClientRect().width + gap;
      return Math.max(cardW, Math.floor(track.clientWidth / cardW - 1) * cardW || cardW);
    };

    const sync = () => {
      const scrollable = track.scrollWidth - track.clientWidth;
      const fits = scrollable < 2;
      if (controls) controls.hidden = fits;
      /* A set that fits entirely centres itself instead of leaving dead
         space on the right (three Barley bottles in a four-slot frame). */
      track.classList.toggle('is-static', fits);
      if (fits) return;

      const ratio = track.clientWidth / track.scrollWidth;
      const progress = track.scrollLeft / scrollable;
      if (thumb) {
        thumb.style.width = Math.max(ratio * 100, 12) + '%';
        thumb.style.transform =
          'translateX(' + progress * ((1 / Math.max(ratio, 0.12)) - 1) * 100 + '%)';
      }
      if (prev) prev.disabled = track.scrollLeft < 2;
      if (next) next.disabled = track.scrollLeft >= scrollable - 2;
    };

    /* The row is tweened here rather than handed to the browser: native smooth
       scrolling — the CSS property and scrollBy({behavior:'smooth'}) both —
       silently does nothing in some engines, which leaves the arrows dead.
       Instant scrollLeft writes work everywhere, so we animate them ourselves. */
    let frame = null;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const glide = delta => {
      const max = track.scrollWidth - track.clientWidth;
      const from = track.scrollLeft;
      const to = Math.max(0, Math.min(max, from + delta));
      const dist = to - from;
      if (!dist) return;

      if (reduced.matches) {
        track.scrollLeft = to;
        sync();
        return;
      }

      const started = performance.now();
      const duration = 380;
      if (frame) cancelAnimationFrame(frame);
      const tick = now => {
        const p = Math.min((now - started) / duration, 1);
        const eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        track.scrollLeft = from + dist * eased;
        sync();
        if (p < 1) frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
    };

    if (prev) prev.addEventListener('click', () => glide(-step()));
    if (next) next.addEventListener('click', () => glide(step()));

    /* sync is a handful of reads and two style writes — cheap enough to run
       straight off the scroll event. Wrapping it in requestAnimationFrame only
       added a dependency that stalls in throttled/background tabs. */
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* Home "+" = add AND land on the box builder (owner decision): the form
       posts /cart/add with return_to=/collections/all — one request whose
       303 carries the customer to the builder with the bottle already in
       the cart. The check flash confirms the click for the moment before
       the page turns; keep it short so it adds almost nothing to the trip. */
    section.querySelectorAll('.gr-ft-card__form').forEach(form => {
      form.addEventListener('submit', event => {
        const btn = form.querySelector('.gr-ft-card__plus');
        if (!btn || btn.disabled || btn.classList.contains('is-adding')) return;
        event.preventDefault();
        btn.classList.add('is-adding');
        window.setTimeout(() => form.submit(), 200);
      });
    });

    sync();
    /* Images settle after layout — recheck once they have height. */
    window.addEventListener('load', sync);
  });
});
